import React from "react";
import "./AboutMePage.scss";

// Assets
import ImageAboutMeBanner from "assets/images/banners/about-me-banner.png";

// Components
import LandingBanner from "components/LandingBanner/LandingBanner";
import Footer from "components/Footer/Footer";
import Text from "components/Headings/Text/Text";
import AnimatedText from "components/Headings/Common/Utils/Animation/AnimatedText";

function AboutMePage() {
  return (
    <div className="aboutMePage">
      <div className="aboutMePage__banner">
        <LandingBanner title={"About Me"} banner={ImageAboutMeBanner} />
      </div>
      <div className="aboutMePage__content">
        <div className="aboutMePage__details">
          <div className="aboutMePage__text">
            <Text>
              <AnimatedText>
                Greetings, I am Naveen Liyanage, currently pursuing my
                undergraduate studies at the University of Moratuwa, Sri Lanka.
                I am enrolled in the Faculty of Information Technology, working
                towards a Bachelor's degree in Information Technology (BSc.
                Information Technology).
              </AnimatedText>
            </Text>
          </div>
          <div className="aboutMePage__text">
            <Text>
              <AnimatedText>
                With a foundation in full-stack web development, I boast over
                three years of hands-on experience employing cutting-edge web
                technologies prevalent in today's industry. My journey began
                with a singular focus on web development, but as my skills
                expanded, so did my repertoire. Today, I am not only proficient
                in web development but also excel in diverse disciplines such as
                logo design, UI/UX design, graphic design, motion design, and 3D
                modeling.
              </AnimatedText>
            </Text>
          </div>
          <div className="aboutMePage__text">
            <Text>
              <AnimatedText>
                Driven by an unyielding passion for web development, I am
                constantly immersed in the ever-evolving landscape of
                technology. I possess a fervent desire to stay at the forefront
                of industry trends, always seeking new opportunities to harness
                innovative technologies. My dedication extends beyond mere
                technical proficiency; I am committed to transforming creative
                visions into reality, consistently delivering high-quality
                products that exceed client expectations.
              </AnimatedText>
            </Text>
          </div>
          <div className="aboutMePage__text">
            <Text>
              <AnimatedText>
                I am eager to contribute my expertise and creativity to your
                projects, ensuring they not only meet but exceed the standards
                of excellence. Let's collaborate to turn your ideas into
                captivating digital experiences.
              </AnimatedText>
            </Text>
          </div>
        </div>
      </div>
      <div className="aboutMePage__footer">
        <Footer />
      </div>
    </div>
  );
}

export default AboutMePage;
